import { finish, error } from '../../../modules/events/actions/push-recent';
import api from '../../../api';

let localStorage = typeof window !== 'undefined' && window.localStorage;

if (localStorage) {
    try {
        localStorage.setItem('_test_', '_test_');
    } catch (e) {
        localStorage = null;
    }
}

export function push(dispatch, action, state) {
    if (localStorage) {
        localStorage.setItem(
            'recentEvents',
            JSON.stringify(state.events.get('recent').toJS())
        );
    }
}
